import { SkeletonLoader } from '@frontend/design-system';
import { skeletonRowStyles, skeletonTextContainerStyles } from './contact-row-skeleton.styles';

type ContactRowSkeletonProps = {
  showSubtext?: boolean;
  className?: string;
};

/**
 * Skeletal loading placeholder for contact list rows.
 * Displays a circular avatar skeleton and text line skeletons with shimmer animation.
 */
export const ContactRowSkeleton = ({ showSubtext = false, className }: ContactRowSkeletonProps) => (
  <div
    className={className ? `${skeletonRowStyles} ${className}` : skeletonRowStyles}
    aria-busy
    aria-label='Loading contact'
  >
    <SkeletonLoader width={32} height={32} shape='circle' animation='shimmer' />
    <div className={skeletonTextContainerStyles}>
      <SkeletonLoader width={120} height={14} shape='rectangle' animation='shimmer' />
      {showSubtext && <SkeletonLoader width={80} height={12} shape='rectangle' animation='shimmer' />}
    </div>
  </div>
);
